import React from "react";

const NotificationPing = ({ className='' }) => (
  <span className={`flex h-2 w-2 items-center justify-center relative ${className}`}>
    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
    <span className="inline-flex rounded-full h-1.5 w-1.5 bg-red-500"></span>
  </span>
)

export default NotificationPing;